// extracted by mini-css-extract-plugin
export default {"icon":"TablePlusIcon_icon__bR0-C"};